export const DEFINE_MODULE = {
  name: "vai trò",
  fields: "roles"
}
